import { useContainerDimensions } from 'features/dashboard/widgets/firstline/FirstlineDataViewerDesktop';
import { AutoshipsHeader } from 'features/dashboard/widgets/firstline/headers/AutoshipHeaders';
import { CheckAssuranceHeader } from 'features/dashboard/widgets/firstline/headers/CheckAssuranceHeader';
import { FitlineClubMemberHeader } from 'features/dashboard/widgets/firstline/headers/FitlineClubMemberHeader';
import {
  CurrentQualificationHeader,
  HighestQualificationHeader,
  PreviousQualificationHeader
} from 'features/dashboard/widgets/firstline/headers/QualificationHeaders';
import {
  OpenAutoshipVolumeHeader,
  PersonalSalesHeader,
  SixLevelSalesHeader,
  StructureSalesHeader
} from 'features/dashboard/widgets/firstline/headers/SalesHeaders';
import { Month } from 'libs/time';
import { useRef } from 'react';
import { IUserProfile } from 'types';

import './TeamTable.scss';
import { TeamTableRow } from './TeamTableRow';
import { useDownlineContext } from '../DownlineContext';

interface ITeamTableProps {
  readonly upline: ReadonlyArray<IUserProfile>;
  readonly selectedUser?: IUserProfile;
  readonly downline: ReadonlyArray<IUserProfile>;
  readonly onUserClick: (userId: string) => void;
  readonly onExploreUserDownline: (userId: string) => void;
}

export function TeamTable({
  upline,
  downline,
  selectedUser,
  onExploreUserDownline
}: ITeamTableProps) {
  const componentRef = useRef<HTMLTableElement>(null);
  const { width } = useContainerDimensions(componentRef);
  const { selectedPeriod } = useDownlineContext();
  const isCurrentMonth = selectedPeriod.getTime() == Month.today().getTime();

  return (
    <div className="block overflow-y-auto" ref={componentRef}>
      <table className="w-full table-auto">
        <thead className="bg-body sticky top-0">
          <tr className="divide-x divide-slate-100">
            <th></th>
            <th></th>
            <th className="text-md font-medium text-gray-900 p-2 text-middle">
              <CheckAssuranceHeader iconOnly />
            </th>
            <th className="text-md font-medium text-gray-900 p-2 text-middle">
              <CurrentQualificationHeader iconOnly />
            </th>
            <th className="text-md font-medium text-gray-900 p-2 text-middle">
              <PreviousQualificationHeader iconOnly />
            </th>
            <th className="text-md font-medium text-gray-900 p-2 text-middle">
              <HighestQualificationHeader iconOnly />
            </th>
            <th className="text-md font-medium text-gray-900 p-2 text-middle">
              <FitlineClubMemberHeader iconOnly />
            </th>
            <th className="text-md font-medium text-gray-900 py-2 px-4 text-middle">
              <AutoshipsHeader />
            </th>
            <th className="text-md font-medium text-gray-900 p-2 text-middle">
              <PersonalSalesHeader />
            </th>

            {isCurrentMonth && (
              <th className="text-md font-medium text-gray-900 py-2 px-4 text-middle">
                <OpenAutoshipVolumeHeader />
              </th>
            )}
            <th
              colSpan={2}
              className="text-md font-medium text-gray-900 py-2 px-4 text-middle"
            >
              <SixLevelSalesHeader />
            </th>
            <th
              colSpan={2}
              className="text-md font-medium text-gray-900 py-2 px-4 text-center"
            >
              <StructureSalesHeader />
            </th>
          </tr>
        </thead>
        <tbody>
          {upline.map(row => (
            <TeamTableRow
              containerWidth={width}
              user={row}
              type="upline"
              onExploreDownline={onExploreUserDownline}
              key={`user__${row.userId}`}
            />
          ))}
          {selectedUser && (
            <TeamTableRow
              containerWidth={width}
              user={selectedUser}
              type="selectedUser"
              onExploreDownline={onExploreUserDownline}
              key={`user__${selectedUser.userId}`}
            />
          )}
          {downline.map(row => (
            <TeamTableRow
              containerWidth={width}
              user={row}
              type="downline"
              onExploreDownline={onExploreUserDownline}
              key={`user__${row.userId}`}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
